import React from 'react';
import { ApiReferenceReact } from '@scalar/api-reference-react';
import '@scalar/api-reference-react/style.css';
import { useQuery } from 'react-query';
import { Box } from '@mui/material';
import { getPlaygroundToken } from '../../api/developerApi';

export default function DocsPage() {
  // staleTime: 50min — refreshes before the 1hr token expiry.
  // On error or loading, token is '' — Scalar still renders, user pastes their own key.
  const { data } = useQuery('playground-token', getPlaygroundToken, {
    staleTime: 50 * 60 * 1000,
    retry: 1,
  });

  return (
    // Negative margin escapes the portal's p:{xs:2, sm:3} content padding
    // so Scalar can render its own full-width layout flush to the content area edges.
    <Box sx={{ mx: { xs: -2, sm: -3 }, mt: { xs: -2, sm: -3 } }}>
      <ApiReferenceReact
        configuration={{
          spec: { url: '/openapi.yaml' },
          authentication: {
            preferredSecurityScheme: 'BearerAuth',
            bearer: { token: data?.token ?? '' },
          },
          hideDownloadButton: false,
          theme: 'default',
        }}
      />
    </Box>
  );
}
